
export const courseType = (courseID: string, credits: number ): string => {

  const OddGENsCourse = ["GEN341","GEN342","GEN004","GEN333", "GENS442", "GENS341"];
  const specialCases = ['CMP111'];

  const courseCode = courseID.slice(0,3);
  const courseNumber = courseID.slice(4,7);
  const course = courseCode + courseNumber;

  if (specialCases.includes(course))
    return 'Error'
  if (courseCode === 'GEN' && !OddGENsCourse.includes(course))
    return 'GEN';
  if (credits === 1)
    return '1Crds';
  if (credits === 2 || OddGENsCourse.includes(course))
    return '2Crds';
  if (credits === 3)
    return '3Crds';
  if (credits === 4)
    return '4Crds';
  if (courseNumber === '481'  || courseNumber === '480'  || courseNumber === '281' || courseNumber === '381' )
    return 'PassOrFail';
  else return '';
} 